import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

export enum SettingsPage {
  MY_ACCOUNT = 'account',
  NOTIFICATIONS = 'notifications',
  SECURITY = 'security',
  GLOBAL_PREFERENCES = 'globalPreferences',
  PRIVACY_AND_SAFETY = 'privacyAndSafety',
  PAYMENT = 'payment',
}

export const TITLES: { [key in SettingsPage]: MessageDescriptor } =
  defineMessages<SettingsPage>({
    [SettingsPage.MY_ACCOUNT]: {
      defaultMessage: 'My Account',
    },
    [SettingsPage.NOTIFICATIONS]: {
      defaultMessage: 'Notifications',
    },
    [SettingsPage.SECURITY]: {
      defaultMessage: 'Login & Security',
    },
    [SettingsPage.GLOBAL_PREFERENCES]: {
      defaultMessage: 'Global preferences',
    },
    [SettingsPage.PRIVACY_AND_SAFETY]: {
      defaultMessage: 'Privacy & Safety',
    },
    [SettingsPage.PAYMENT]: {
      defaultMessage: 'Payment',
    },
  });
